/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AppWsSlugRouteImport } from './routes/_app/$wsSlug'
import { Route as AppOnboardingRouteImport } from './routes/_app/onboarding'
import { Route as AuthAcceptInviteRouteImport } from './routes/_auth/accept-invite'
import { Route as AuthChangePasswordRouteImport } from './routes/_auth/change-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as AppWsSlugIndexRouteImport } from './routes/_app/$wsSlug/index'
import { Route as AppWsSlugCalendarRouteImport } from './routes/_app/$wsSlug/calendar'
import { Route as AppWsSlugInboxRouteImport } from './routes/_app/$wsSlug/inbox'
import { Route as AppWsSlugMyWorkRouteImport } from './routes/_app/$wsSlug/my-work'
import { Route as AppWsSlugProfileRouteImport } from './routes/_app/$wsSlug/profile'
import { Route as AppWsSlugProjectsRouteImport } from './routes/_app/$wsSlug/projects'
import { Route as AppWsSlugSettingsRouteImport } from './routes/_app/$wsSlug/settings'
import { Route as AppWsSlugTimeRouteImport } from './routes/_app/$wsSlug/time'
import { Route as AppWsSlugUsersRouteImport } from './routes/_app/$wsSlug/users'
import { Route as AppAdminFeedbackRouteImport } from './routes/_app/admin/feedback'
import { Route as AppAdminRolesRouteImport } from './routes/_app/admin/roles'
import { Route as AppAdminUsersRouteImport } from './routes/_app/admin/users'
import { Route as AppAdminWhatsappRouteImport } from './routes/_app/admin/whatsapp'
import { Route as AppAdminWorkspacesRouteImport } from './routes/_app/admin/workspaces'
import { Route as AuthResetPasswordConfirmRouteImport } from './routes/_auth/reset-password.confirm'
import { Route as PublicLegalPrivacyRouteImport } from './routes/_public/legal.privacy'
import { Route as PublicLegalTermsRouteImport } from './routes/_public/legal.terms'
import { Route as AppWsSlugProjectsIndexRouteImport } from './routes/_app/$wsSlug/projects.index'
import { Route as AppWsSlugProjectsProjectSlugRouteImport } from './routes/_app/$wsSlug/projects.$projectSlug'
import { Route as AppWsSlugProjectsArchivadosRouteImport } from './routes/_app/$wsSlug/projects.archivados'
import { Route as AppWsSlugSettingsAreasRouteImport } from './routes/_app/$wsSlug/settings/areas'
import { Route as AppWsSlugSettingsGeneralRouteImport } from './routes/_app/$wsSlug/settings/general'
import { Route as AppWsSlugSettingsIntegrationsRouteImport } from './routes/_app/$wsSlug/settings/integrations'
import { Route as AppWsSlugSettingsMembersRouteImport } from './routes/_app/$wsSlug/settings/members'
import { Route as AppWsSlugSettingsTelegramRouteImport } from './routes/_app/$wsSlug/settings/telegram'
import { Route as AppWsSlugSettingsWhatsappRouteImport } from './routes/_app/$wsSlug/settings/whatsapp'
import { Route as AppWsSlugUsersUserIdRouteImport } from './routes/_app/$wsSlug/users.$userId'
import { Route as AppWsSlugProjectsProjectSlugItemIdRouteImport } from './routes/_app/$wsSlug/projects.$projectSlug/$itemId'
import { Route as AppWsSlugProjectsProjectSlugArchivadasRouteImport } from './routes/_app/$wsSlug/projects.$projectSlug/archivadas'
import { Route as AppWsSlugProjectsProjectSlugBoardRouteImport } from './routes/_app/$wsSlug/projects.$projectSlug/board'
import { Route as AppWsSlugProjectsProjectSlugCyclesRouteImport } from './routes/_app/$wsSlug/projects.$projectSlug/cycles'
import { Route as AppWsSlugProjectsProjectSlugDashboardRouteImport } from './routes/_app/$wsSlug/projects.$projectSlug/dashboard'
import { Route as AppWsSlugProjectsProjectSlugGanttRouteImport } from './routes/_app/$wsSlug/projects.$projectSlug/gantt'
import { Route as AppWsSlugProjectsProjectSlugKpisRouteImport } from './routes/_app/$wsSlug/projects.$projectSlug/kpis'
import { Route as AppWsSlugProjectsProjectSlugListRouteImport } from './routes/_app/$wsSlug/projects.$projectSlug/list'
import { Route as AppWsSlugProjectsProjectSlugMinutaRouteImport } from './routes/_app/$wsSlug/projects.$projectSlug/minuta'
import { Route as AppWsSlugProjectsProjectSlugModulesRouteImport } from './routes/_app/$wsSlug/projects.$projectSlug/modules'
import { Route as AppWsSlugProjectsProjectSlugRecurrentesRouteImport } from './routes/_app/$wsSlug/projects.$projectSlug/recurrentes'
import { Route as AppWsSlugProjectsProjectSlugSettingsRouteImport } from './routes/_app/$wsSlug/projects.$projectSlug/settings'
import { Route as AppWsSlugProjectsProjectSlugCyclesCycleIdRouteImport } from './routes/_app/$wsSlug/projects.$projectSlug/cycles.$cycleId'
import { Route as AppWsSlugProjectsProjectSlugModulesModuleIdRouteImport } from './routes/_app/$wsSlug/projects.$projectSlug/modules.$moduleId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AppWsSlugRoute = AppWsSlugRouteImport.update({
  id: '/$wsSlug',
  path: '/$wsSlug',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRoute,
} as any)
const AuthAcceptInviteRoute = AuthAcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChangePasswordRoute = AuthChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const AppWsSlugIndexRoute = AppWsSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWsSlugRoute,
} as any)
const AppWsSlugCalendarRoute = AppWsSlugCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppWsSlugRoute,
} as any)
const AppWsSlugInboxRoute = AppWsSlugInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppWsSlugRoute,
} as any)
const AppWsSlugMyWorkRoute = AppWsSlugMyWorkRouteImport.update({
  id: '/my-work',
  path: '/my-work',
  getParentRoute: () => AppWsSlugRoute,
} as any)
const AppWsSlugProfileRoute = AppWsSlugProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppWsSlugRoute,
} as any)
const AppWsSlugProjectsRoute = AppWsSlugProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppWsSlugRoute,
} as any)
const AppWsSlugSettingsRoute = AppWsSlugSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppWsSlugRoute,
} as any)
const AppWsSlugTimeRoute = AppWsSlugTimeRouteImport.update({
  id: '/time',
  path: '/time',
  getParentRoute: () => AppWsSlugRoute,
} as any)
const AppWsSlugUsersRoute = AppWsSlugUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppWsSlugRoute,
} as any)
const AppAdminFeedbackRoute = AppAdminFeedbackRouteImport.update({
  id: '/admin/feedback',
  path: '/admin/feedback',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRolesRoute = AppAdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminWhatsappRoute = AppAdminWhatsappRouteImport.update({
  id: '/admin/whatsapp',
  path: '/admin/whatsapp',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminWorkspacesRoute = AppAdminWorkspacesRouteImport.update({
  id: '/admin/workspaces',
  path: '/admin/workspaces',
  getParentRoute: () => AppRoute,
} as any)
const AuthResetPasswordConfirmRoute =
  AuthResetPasswordConfirmRouteImport.update({
    id: '/confirm',
    path: '/confirm',
    getParentRoute: () => AuthResetPasswordRoute,
  } as any)
const PublicLegalPrivacyRoute = PublicLegalPrivacyRouteImport.update({
  id: '/legal/privacy',
  path: '/legal/privacy',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLegalTermsRoute = PublicLegalTermsRouteImport.update({
  id: '/legal/terms',
  path: '/legal/terms',
  getParentRoute: () => PublicRoute,
} as any)
const AppWsSlugProjectsIndexRoute = AppWsSlugProjectsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWsSlugProjectsRoute,
} as any)
const AppWsSlugProjectsProjectSlugRoute =
  AppWsSlugProjectsProjectSlugRouteImport.update({
    id: '/$projectSlug',
    path: '/$projectSlug',
    getParentRoute: () => AppWsSlugProjectsRoute,
  } as any)
const AppWsSlugProjectsArchivadosRoute =
  AppWsSlugProjectsArchivadosRouteImport.update({
    id: '/archivados',
    path: '/archivados',
    getParentRoute: () => AppWsSlugProjectsRoute,
  } as any)
const AppWsSlugSettingsAreasRoute = AppWsSlugSettingsAreasRouteImport.update({
  id: '/areas',
  path: '/areas',
  getParentRoute: () => AppWsSlugSettingsRoute,
} as any)
const AppWsSlugSettingsGeneralRoute =
  AppWsSlugSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AppWsSlugSettingsRoute,
  } as any)
const AppWsSlugSettingsIntegrationsRoute =
  AppWsSlugSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AppWsSlugSettingsRoute,
  } as any)
const AppWsSlugSettingsMembersRoute =
  AppWsSlugSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AppWsSlugSettingsRoute,
  } as any)
const AppWsSlugSettingsTelegramRoute =
  AppWsSlugSettingsTelegramRouteImport.update({
    id: '/telegram',
    path: '/telegram',
    getParentRoute: () => AppWsSlugSettingsRoute,
  } as any)
const AppWsSlugSettingsWhatsappRoute =
  AppWsSlugSettingsWhatsappRouteImport.update({
    id: '/whatsapp',
    path: '/whatsapp',
    getParentRoute: () => AppWsSlugSettingsRoute,
  } as any)
const AppWsSlugUsersUserIdRoute = AppWsSlugUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AppWsSlugUsersRoute,
} as any)
const AppWsSlugProjectsProjectSlugItemIdRoute =
  AppWsSlugProjectsProjectSlugItemIdRouteImport.update({
    id: '/$itemId',
    path: '/$itemId',
    getParentRoute: () => AppWsSlugProjectsProjectSlugRoute,
  } as any)
const AppWsSlugProjectsProjectSlugArchivadasRoute =
  AppWsSlugProjectsProjectSlugArchivadasRouteImport.update({
    id: '/archivadas',
    path: '/archivadas',
    getParentRoute: () => AppWsSlugProjectsProjectSlugRoute,
  } as any)
const AppWsSlugProjectsProjectSlugBoardRoute =
  AppWsSlugProjectsProjectSlugBoardRouteImport.update({
    id: '/board',
    path: '/board',
    getParentRoute: () => AppWsSlugProjectsProjectSlugRoute,
  } as any)
const AppWsSlugProjectsProjectSlugCyclesRoute =
  AppWsSlugProjectsProjectSlugCyclesRouteImport.update({
    id: '/cycles',
    path: '/cycles',
    getParentRoute: () => AppWsSlugProjectsProjectSlugRoute,
  } as any)
const AppWsSlugProjectsProjectSlugDashboardRoute =
  AppWsSlugProjectsProjectSlugDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AppWsSlugProjectsProjectSlugRoute,
  } as any)
const AppWsSlugProjectsProjectSlugGanttRoute =
  AppWsSlugProjectsProjectSlugGanttRouteImport.update({
    id: '/gantt',
    path: '/gantt',
    getParentRoute: () => AppWsSlugProjectsProjectSlugRoute,
  } as any)
const AppWsSlugProjectsProjectSlugKpisRoute =
  AppWsSlugProjectsProjectSlugKpisRouteImport.update({
    id: '/kpis',
    path: '/kpis',
    getParentRoute: () => AppWsSlugProjectsProjectSlugRoute,
  } as any)
const AppWsSlugProjectsProjectSlugListRoute =
  AppWsSlugProjectsProjectSlugListRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => AppWsSlugProjectsProjectSlugRoute,
  } as any)
const AppWsSlugProjectsProjectSlugMinutaRoute =
  AppWsSlugProjectsProjectSlugMinutaRouteImport.update({
    id: '/minuta',
    path: '/minuta',
    getParentRoute: () => AppWsSlugProjectsProjectSlugRoute,
  } as any)
const AppWsSlugProjectsProjectSlugModulesRoute =
  AppWsSlugProjectsProjectSlugModulesRouteImport.update({
    id: '/modules',
    path: '/modules',
    getParentRoute: () => AppWsSlugProjectsProjectSlugRoute,
  } as any)
const AppWsSlugProjectsProjectSlugRecurrentesRoute =
  AppWsSlugProjectsProjectSlugRecurrentesRouteImport.update({
    id: '/recurrentes',
    path: '/recurrentes',
    getParentRoute: () => AppWsSlugProjectsProjectSlugRoute,
  } as any)
const AppWsSlugProjectsProjectSlugSettingsRoute =
  AppWsSlugProjectsProjectSlugSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppWsSlugProjectsProjectSlugRoute,
  } as any)
const AppWsSlugProjectsProjectSlugCyclesCycleIdRoute =
  AppWsSlugProjectsProjectSlugCyclesCycleIdRouteImport.update({
    id: '/$cycleId',
    path: '/$cycleId',
    getParentRoute: () => AppWsSlugProjectsProjectSlugCyclesRoute,
  } as any)
const AppWsSlugProjectsProjectSlugModulesModuleIdRoute =
  AppWsSlugProjectsProjectSlugModulesModuleIdRouteImport.update({
    id: '/$moduleId',
    path: '/$moduleId',
    getParentRoute: () => AppWsSlugProjectsProjectSlugModulesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/$wsSlug': typeof AppWsSlugRouteWithChildren
  '/onboarding': typeof AppOnboardingRoute
  '/accept-invite': typeof AuthAcceptInviteRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRouteWithChildren
  '/$wsSlug/calendar': typeof AppWsSlugCalendarRoute
  '/$wsSlug/inbox': typeof AppWsSlugInboxRoute
  '/$wsSlug/my-work': typeof AppWsSlugMyWorkRoute
  '/$wsSlug/profile': typeof AppWsSlugProfileRoute
  '/$wsSlug/projects': typeof AppWsSlugProjectsRouteWithChildren
  '/$wsSlug/settings': typeof AppWsSlugSettingsRouteWithChildren
  '/$wsSlug/time': typeof AppWsSlugTimeRoute
  '/$wsSlug/users': typeof AppWsSlugUsersRouteWithChildren
  '/admin/feedback': typeof AppAdminFeedbackRoute
  '/admin/roles': typeof AppAdminRolesRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/admin/whatsapp': typeof AppAdminWhatsappRoute
  '/admin/workspaces': typeof AppAdminWorkspacesRoute
  '/reset-password/confirm': typeof AuthResetPasswordConfirmRoute
  '/legal/privacy': typeof PublicLegalPrivacyRoute
  '/legal/terms': typeof PublicLegalTermsRoute
  '/$wsSlug/': typeof AppWsSlugIndexRoute
  '/$wsSlug/projects/$projectSlug': typeof AppWsSlugProjectsProjectSlugRouteWithChildren
  '/$wsSlug/projects/archivados': typeof AppWsSlugProjectsArchivadosRoute
  '/$wsSlug/settings/areas': typeof AppWsSlugSettingsAreasRoute
  '/$wsSlug/settings/general': typeof AppWsSlugSettingsGeneralRoute
  '/$wsSlug/settings/integrations': typeof AppWsSlugSettingsIntegrationsRoute
  '/$wsSlug/settings/members': typeof AppWsSlugSettingsMembersRoute
  '/$wsSlug/settings/telegram': typeof AppWsSlugSettingsTelegramRoute
  '/$wsSlug/settings/whatsapp': typeof AppWsSlugSettingsWhatsappRoute
  '/$wsSlug/users/$userId': typeof AppWsSlugUsersUserIdRoute
  '/$wsSlug/projects/': typeof AppWsSlugProjectsIndexRoute
  '/$wsSlug/projects/$projectSlug/$itemId': typeof AppWsSlugProjectsProjectSlugItemIdRoute
  '/$wsSlug/projects/$projectSlug/archivadas': typeof AppWsSlugProjectsProjectSlugArchivadasRoute
  '/$wsSlug/projects/$projectSlug/board': typeof AppWsSlugProjectsProjectSlugBoardRoute
  '/$wsSlug/projects/$projectSlug/cycles': typeof AppWsSlugProjectsProjectSlugCyclesRouteWithChildren
  '/$wsSlug/projects/$projectSlug/dashboard': typeof AppWsSlugProjectsProjectSlugDashboardRoute
  '/$wsSlug/projects/$projectSlug/gantt': typeof AppWsSlugProjectsProjectSlugGanttRoute
  '/$wsSlug/projects/$projectSlug/kpis': typeof AppWsSlugProjectsProjectSlugKpisRoute
  '/$wsSlug/projects/$projectSlug/list': typeof AppWsSlugProjectsProjectSlugListRoute
  '/$wsSlug/projects/$projectSlug/minuta': typeof AppWsSlugProjectsProjectSlugMinutaRoute
  '/$wsSlug/projects/$projectSlug/modules': typeof AppWsSlugProjectsProjectSlugModulesRouteWithChildren
  '/$wsSlug/projects/$projectSlug/recurrentes': typeof AppWsSlugProjectsProjectSlugRecurrentesRoute
  '/$wsSlug/projects/$projectSlug/settings': typeof AppWsSlugProjectsProjectSlugSettingsRoute
  '/$wsSlug/projects/$projectSlug/cycles/$cycleId': typeof AppWsSlugProjectsProjectSlugCyclesCycleIdRoute
  '/$wsSlug/projects/$projectSlug/modules/$moduleId': typeof AppWsSlugProjectsProjectSlugModulesModuleIdRoute
}
export interface FileRoutesByTo {
  '/': typeof PublicIndexRoute
  '/onboarding': typeof AppOnboardingRoute
  '/accept-invite': typeof AuthAcceptInviteRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRouteWithChildren
  '/$wsSlug/calendar': typeof AppWsSlugCalendarRoute
  '/$wsSlug/inbox': typeof AppWsSlugInboxRoute
  '/$wsSlug/my-work': typeof AppWsSlugMyWorkRoute
  '/$wsSlug/profile': typeof AppWsSlugProfileRoute
  '/$wsSlug/settings': typeof AppWsSlugSettingsRouteWithChildren
  '/$wsSlug/time': typeof AppWsSlugTimeRoute
  '/$wsSlug/users': typeof AppWsSlugUsersRouteWithChildren
  '/admin/feedback': typeof AppAdminFeedbackRoute
  '/admin/roles': typeof AppAdminRolesRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/admin/whatsapp': typeof AppAdminWhatsappRoute
  '/admin/workspaces': typeof AppAdminWorkspacesRoute
  '/reset-password/confirm': typeof AuthResetPasswordConfirmRoute
  '/legal/privacy': typeof PublicLegalPrivacyRoute
  '/legal/terms': typeof PublicLegalTermsRoute
  '/$wsSlug': typeof AppWsSlugIndexRoute
  '/$wsSlug/projects/$projectSlug': typeof AppWsSlugProjectsProjectSlugRouteWithChildren
  '/$wsSlug/projects/archivados': typeof AppWsSlugProjectsArchivadosRoute
  '/$wsSlug/settings/areas': typeof AppWsSlugSettingsAreasRoute
  '/$wsSlug/settings/general': typeof AppWsSlugSettingsGeneralRoute
  '/$wsSlug/settings/integrations': typeof AppWsSlugSettingsIntegrationsRoute
  '/$wsSlug/settings/members': typeof AppWsSlugSettingsMembersRoute
  '/$wsSlug/settings/telegram': typeof AppWsSlugSettingsTelegramRoute
  '/$wsSlug/settings/whatsapp': typeof AppWsSlugSettingsWhatsappRoute
  '/$wsSlug/users/$userId': typeof AppWsSlugUsersUserIdRoute
  '/$wsSlug/projects': typeof AppWsSlugProjectsIndexRoute
  '/$wsSlug/projects/$projectSlug/$itemId': typeof AppWsSlugProjectsProjectSlugItemIdRoute
  '/$wsSlug/projects/$projectSlug/archivadas': typeof AppWsSlugProjectsProjectSlugArchivadasRoute
  '/$wsSlug/projects/$projectSlug/board': typeof AppWsSlugProjectsProjectSlugBoardRoute
  '/$wsSlug/projects/$projectSlug/cycles': typeof AppWsSlugProjectsProjectSlugCyclesRouteWithChildren
  '/$wsSlug/projects/$projectSlug/dashboard': typeof AppWsSlugProjectsProjectSlugDashboardRoute
  '/$wsSlug/projects/$projectSlug/gantt': typeof AppWsSlugProjectsProjectSlugGanttRoute
  '/$wsSlug/projects/$projectSlug/kpis': typeof AppWsSlugProjectsProjectSlugKpisRoute
  '/$wsSlug/projects/$projectSlug/list': typeof AppWsSlugProjectsProjectSlugListRoute
  '/$wsSlug/projects/$projectSlug/minuta': typeof AppWsSlugProjectsProjectSlugMinutaRoute
  '/$wsSlug/projects/$projectSlug/modules': typeof AppWsSlugProjectsProjectSlugModulesRouteWithChildren
  '/$wsSlug/projects/$projectSlug/recurrentes': typeof AppWsSlugProjectsProjectSlugRecurrentesRoute
  '/$wsSlug/projects/$projectSlug/settings': typeof AppWsSlugProjectsProjectSlugSettingsRoute
  '/$wsSlug/projects/$projectSlug/cycles/$cycleId': typeof AppWsSlugProjectsProjectSlugCyclesCycleIdRoute
  '/$wsSlug/projects/$projectSlug/modules/$moduleId': typeof AppWsSlugProjectsProjectSlugModulesModuleIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_app/$wsSlug': typeof AppWsSlugRouteWithChildren
  '/_app/onboarding': typeof AppOnboardingRoute
  '/_auth/accept-invite': typeof AuthAcceptInviteRoute
  '/_auth/change-password': typeof AuthChangePasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRouteWithChildren
  '/_public/': typeof PublicIndexRoute
  '/_app/$wsSlug/calendar': typeof AppWsSlugCalendarRoute
  '/_app/$wsSlug/inbox': typeof AppWsSlugInboxRoute
  '/_app/$wsSlug/my-work': typeof AppWsSlugMyWorkRoute
  '/_app/$wsSlug/profile': typeof AppWsSlugProfileRoute
  '/_app/$wsSlug/projects': typeof AppWsSlugProjectsRouteWithChildren
  '/_app/$wsSlug/settings': typeof AppWsSlugSettingsRouteWithChildren
  '/_app/$wsSlug/time': typeof AppWsSlugTimeRoute
  '/_app/$wsSlug/users': typeof AppWsSlugUsersRouteWithChildren
  '/_app/admin/feedback': typeof AppAdminFeedbackRoute
  '/_app/admin/roles': typeof AppAdminRolesRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/admin/whatsapp': typeof AppAdminWhatsappRoute
  '/_app/admin/workspaces': typeof AppAdminWorkspacesRoute
  '/_auth/reset-password/confirm': typeof AuthResetPasswordConfirmRoute
  '/_public/legal/privacy': typeof PublicLegalPrivacyRoute
  '/_public/legal/terms': typeof PublicLegalTermsRoute
  '/_app/$wsSlug/': typeof AppWsSlugIndexRoute
  '/_app/$wsSlug/projects/$projectSlug': typeof AppWsSlugProjectsProjectSlugRouteWithChildren
  '/_app/$wsSlug/projects/archivados': typeof AppWsSlugProjectsArchivadosRoute
  '/_app/$wsSlug/settings/areas': typeof AppWsSlugSettingsAreasRoute
  '/_app/$wsSlug/settings/general': typeof AppWsSlugSettingsGeneralRoute
  '/_app/$wsSlug/settings/integrations': typeof AppWsSlugSettingsIntegrationsRoute
  '/_app/$wsSlug/settings/members': typeof AppWsSlugSettingsMembersRoute
  '/_app/$wsSlug/settings/telegram': typeof AppWsSlugSettingsTelegramRoute
  '/_app/$wsSlug/settings/whatsapp': typeof AppWsSlugSettingsWhatsappRoute
  '/_app/$wsSlug/users/$userId': typeof AppWsSlugUsersUserIdRoute
  '/_app/$wsSlug/projects/': typeof AppWsSlugProjectsIndexRoute
  '/_app/$wsSlug/projects/$projectSlug/$itemId': typeof AppWsSlugProjectsProjectSlugItemIdRoute
  '/_app/$wsSlug/projects/$projectSlug/archivadas': typeof AppWsSlugProjectsProjectSlugArchivadasRoute
  '/_app/$wsSlug/projects/$projectSlug/board': typeof AppWsSlugProjectsProjectSlugBoardRoute
  '/_app/$wsSlug/projects/$projectSlug/cycles': typeof AppWsSlugProjectsProjectSlugCyclesRouteWithChildren
  '/_app/$wsSlug/projects/$projectSlug/dashboard': typeof AppWsSlugProjectsProjectSlugDashboardRoute
  '/_app/$wsSlug/projects/$projectSlug/gantt': typeof AppWsSlugProjectsProjectSlugGanttRoute
  '/_app/$wsSlug/projects/$projectSlug/kpis': typeof AppWsSlugProjectsProjectSlugKpisRoute
  '/_app/$wsSlug/projects/$projectSlug/list': typeof AppWsSlugProjectsProjectSlugListRoute
  '/_app/$wsSlug/projects/$projectSlug/minuta': typeof AppWsSlugProjectsProjectSlugMinutaRoute
  '/_app/$wsSlug/projects/$projectSlug/modules': typeof AppWsSlugProjectsProjectSlugModulesRouteWithChildren
  '/_app/$wsSlug/projects/$projectSlug/recurrentes': typeof AppWsSlugProjectsProjectSlugRecurrentesRoute
  '/_app/$wsSlug/projects/$projectSlug/settings': typeof AppWsSlugProjectsProjectSlugSettingsRoute
  '/_app/$wsSlug/projects/$projectSlug/cycles/$cycleId': typeof AppWsSlugProjectsProjectSlugCyclesCycleIdRoute
  '/_app/$wsSlug/projects/$projectSlug/modules/$moduleId': typeof AppWsSlugProjectsProjectSlugModulesModuleIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$wsSlug'
    | '/onboarding'
    | '/accept-invite'
    | '/change-password'
    | '/login'
    | '/reset-password'
    | '/$wsSlug/calendar'
    | '/$wsSlug/inbox'
    | '/$wsSlug/my-work'
    | '/$wsSlug/profile'
    | '/$wsSlug/projects'
    | '/$wsSlug/settings'
    | '/$wsSlug/time'
    | '/$wsSlug/users'
    | '/admin/feedback'
    | '/admin/roles'
    | '/admin/users'
    | '/admin/whatsapp'
    | '/admin/workspaces'
    | '/reset-password/confirm'
    | '/legal/privacy'
    | '/legal/terms'
    | '/$wsSlug/'
    | '/$wsSlug/projects/$projectSlug'
    | '/$wsSlug/projects/archivados'
    | '/$wsSlug/settings/areas'
    | '/$wsSlug/settings/general'
    | '/$wsSlug/settings/integrations'
    | '/$wsSlug/settings/members'
    | '/$wsSlug/settings/telegram'
    | '/$wsSlug/settings/whatsapp'
    | '/$wsSlug/users/$userId'
    | '/$wsSlug/projects/'
    | '/$wsSlug/projects/$projectSlug/$itemId'
    | '/$wsSlug/projects/$projectSlug/archivadas'
    | '/$wsSlug/projects/$projectSlug/board'
    | '/$wsSlug/projects/$projectSlug/cycles'
    | '/$wsSlug/projects/$projectSlug/dashboard'
    | '/$wsSlug/projects/$projectSlug/gantt'
    | '/$wsSlug/projects/$projectSlug/kpis'
    | '/$wsSlug/projects/$projectSlug/list'
    | '/$wsSlug/projects/$projectSlug/minuta'
    | '/$wsSlug/projects/$projectSlug/modules'
    | '/$wsSlug/projects/$projectSlug/recurrentes'
    | '/$wsSlug/projects/$projectSlug/settings'
    | '/$wsSlug/projects/$projectSlug/cycles/$cycleId'
    | '/$wsSlug/projects/$projectSlug/modules/$moduleId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/accept-invite'
    | '/change-password'
    | '/login'
    | '/reset-password'
    | '/$wsSlug/calendar'
    | '/$wsSlug/inbox'
    | '/$wsSlug/my-work'
    | '/$wsSlug/profile'
    | '/$wsSlug/settings'
    | '/$wsSlug/time'
    | '/$wsSlug/users'
    | '/admin/feedback'
    | '/admin/roles'
    | '/admin/users'
    | '/admin/whatsapp'
    | '/admin/workspaces'
    | '/reset-password/confirm'
    | '/legal/privacy'
    | '/legal/terms'
    | '/$wsSlug'
    | '/$wsSlug/projects/$projectSlug'
    | '/$wsSlug/projects/archivados'
    | '/$wsSlug/settings/areas'
    | '/$wsSlug/settings/general'
    | '/$wsSlug/settings/integrations'
    | '/$wsSlug/settings/members'
    | '/$wsSlug/settings/telegram'
    | '/$wsSlug/settings/whatsapp'
    | '/$wsSlug/users/$userId'
    | '/$wsSlug/projects'
    | '/$wsSlug/projects/$projectSlug/$itemId'
    | '/$wsSlug/projects/$projectSlug/archivadas'
    | '/$wsSlug/projects/$projectSlug/board'
    | '/$wsSlug/projects/$projectSlug/cycles'
    | '/$wsSlug/projects/$projectSlug/dashboard'
    | '/$wsSlug/projects/$projectSlug/gantt'
    | '/$wsSlug/projects/$projectSlug/kpis'
    | '/$wsSlug/projects/$projectSlug/list'
    | '/$wsSlug/projects/$projectSlug/minuta'
    | '/$wsSlug/projects/$projectSlug/modules'
    | '/$wsSlug/projects/$projectSlug/recurrentes'
    | '/$wsSlug/projects/$projectSlug/settings'
    | '/$wsSlug/projects/$projectSlug/cycles/$cycleId'
    | '/$wsSlug/projects/$projectSlug/modules/$moduleId'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_public'
    | '/_app/$wsSlug'
    | '/_app/onboarding'
    | '/_auth/accept-invite'
    | '/_auth/change-password'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_public/'
    | '/_app/$wsSlug/calendar'
    | '/_app/$wsSlug/inbox'
    | '/_app/$wsSlug/my-work'
    | '/_app/$wsSlug/profile'
    | '/_app/$wsSlug/projects'
    | '/_app/$wsSlug/settings'
    | '/_app/$wsSlug/time'
    | '/_app/$wsSlug/users'
    | '/_app/admin/feedback'
    | '/_app/admin/roles'
    | '/_app/admin/users'
    | '/_app/admin/whatsapp'
    | '/_app/admin/workspaces'
    | '/_auth/reset-password/confirm'
    | '/_public/legal/privacy'
    | '/_public/legal/terms'
    | '/_app/$wsSlug/'
    | '/_app/$wsSlug/projects/$projectSlug'
    | '/_app/$wsSlug/projects/archivados'
    | '/_app/$wsSlug/settings/areas'
    | '/_app/$wsSlug/settings/general'
    | '/_app/$wsSlug/settings/integrations'
    | '/_app/$wsSlug/settings/members'
    | '/_app/$wsSlug/settings/telegram'
    | '/_app/$wsSlug/settings/whatsapp'
    | '/_app/$wsSlug/users/$userId'
    | '/_app/$wsSlug/projects/'
    | '/_app/$wsSlug/projects/$projectSlug/$itemId'
    | '/_app/$wsSlug/projects/$projectSlug/archivadas'
    | '/_app/$wsSlug/projects/$projectSlug/board'
    | '/_app/$wsSlug/projects/$projectSlug/cycles'
    | '/_app/$wsSlug/projects/$projectSlug/dashboard'
    | '/_app/$wsSlug/projects/$projectSlug/gantt'
    | '/_app/$wsSlug/projects/$projectSlug/kpis'
    | '/_app/$wsSlug/projects/$projectSlug/list'
    | '/_app/$wsSlug/projects/$projectSlug/minuta'
    | '/_app/$wsSlug/projects/$projectSlug/modules'
    | '/_app/$wsSlug/projects/$projectSlug/recurrentes'
    | '/_app/$wsSlug/projects/$projectSlug/settings'
    | '/_app/$wsSlug/projects/$projectSlug/cycles/$cycleId'
    | '/_app/$wsSlug/projects/$projectSlug/modules/$moduleId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/$wsSlug': {
      id: '/_app/$wsSlug'
      path: '/$wsSlug'
      fullPath: '/$wsSlug'
      preLoaderRoute: typeof AppWsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding': {
      id: '/_app/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/accept-invite': {
      id: '/_auth/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AuthAcceptInviteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/change-password': {
      id: '/_auth/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AuthChangePasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_app/$wsSlug/': {
      id: '/_app/$wsSlug/'
      path: '/'
      fullPath: '/$wsSlug/'
      preLoaderRoute: typeof AppWsSlugIndexRouteImport
      parentRoute: typeof AppWsSlugRoute
    }
    '/_app/$wsSlug/calendar': {
      id: '/_app/$wsSlug/calendar'
      path: '/calendar'
      fullPath: '/$wsSlug/calendar'
      preLoaderRoute: typeof AppWsSlugCalendarRouteImport
      parentRoute: typeof AppWsSlugRoute
    }
    '/_app/$wsSlug/inbox': {
      id: '/_app/$wsSlug/inbox'
      path: '/inbox'
      fullPath: '/$wsSlug/inbox'
      preLoaderRoute: typeof AppWsSlugInboxRouteImport
      parentRoute: typeof AppWsSlugRoute
    }
    '/_app/$wsSlug/my-work': {
      id: '/_app/$wsSlug/my-work'
      path: '/my-work'
      fullPath: '/$wsSlug/my-work'
      preLoaderRoute: typeof AppWsSlugMyWorkRouteImport
      parentRoute: typeof AppWsSlugRoute
    }
    '/_app/$wsSlug/profile': {
      id: '/_app/$wsSlug/profile'
      path: '/profile'
      fullPath: '/$wsSlug/profile'
      preLoaderRoute: typeof AppWsSlugProfileRouteImport
      parentRoute: typeof AppWsSlugRoute
    }
    '/_app/$wsSlug/projects': {
      id: '/_app/$wsSlug/projects'
      path: '/projects'
      fullPath: '/$wsSlug/projects'
      preLoaderRoute: typeof AppWsSlugProjectsRouteImport
      parentRoute: typeof AppWsSlugRoute
    }
    '/_app/$wsSlug/settings': {
      id: '/_app/$wsSlug/settings'
      path: '/settings'
      fullPath: '/$wsSlug/settings'
      preLoaderRoute: typeof AppWsSlugSettingsRouteImport
      parentRoute: typeof AppWsSlugRoute
    }
    '/_app/$wsSlug/time': {
      id: '/_app/$wsSlug/time'
      path: '/time'
      fullPath: '/$wsSlug/time'
      preLoaderRoute: typeof AppWsSlugTimeRouteImport
      parentRoute: typeof AppWsSlugRoute
    }
    '/_app/$wsSlug/users': {
      id: '/_app/$wsSlug/users'
      path: '/users'
      fullPath: '/$wsSlug/users'
      preLoaderRoute: typeof AppWsSlugUsersRouteImport
      parentRoute: typeof AppWsSlugRoute
    }
    '/_app/admin/feedback': {
      id: '/_app/admin/feedback'
      path: '/admin/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof AppAdminFeedbackRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/roles': {
      id: '/_app/admin/roles'
      path: '/admin/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AppAdminRolesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/whatsapp': {
      id: '/_app/admin/whatsapp'
      path: '/admin/whatsapp'
      fullPath: '/admin/whatsapp'
      preLoaderRoute: typeof AppAdminWhatsappRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/workspaces': {
      id: '/_app/admin/workspaces'
      path: '/admin/workspaces'
      fullPath: '/admin/workspaces'
      preLoaderRoute: typeof AppAdminWorkspacesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/reset-password/confirm': {
      id: '/_auth/reset-password/confirm'
      path: '/confirm'
      fullPath: '/reset-password/confirm'
      preLoaderRoute: typeof AuthResetPasswordConfirmRouteImport
      parentRoute: typeof AuthResetPasswordRoute
    }
    '/_public/legal/privacy': {
      id: '/_public/legal/privacy'
      path: '/legal/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof PublicLegalPrivacyRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/legal/terms': {
      id: '/_public/legal/terms'
      path: '/legal/terms'
      fullPath: '/legal/terms'
      preLoaderRoute: typeof PublicLegalTermsRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_app/$wsSlug/projects/': {
      id: '/_app/$wsSlug/projects/'
      path: '/'
      fullPath: '/$wsSlug/projects/'
      preLoaderRoute: typeof AppWsSlugProjectsIndexRouteImport
      parentRoute: typeof AppWsSlugProjectsRoute
    }
    '/_app/$wsSlug/projects/$projectSlug': {
      id: '/_app/$wsSlug/projects/$projectSlug'
      path: '/$projectSlug'
      fullPath: '/$wsSlug/projects/$projectSlug'
      preLoaderRoute: typeof AppWsSlugProjectsProjectSlugRouteImport
      parentRoute: typeof AppWsSlugProjectsRoute
    }
    '/_app/$wsSlug/projects/archivados': {
      id: '/_app/$wsSlug/projects/archivados'
      path: '/archivados'
      fullPath: '/$wsSlug/projects/archivados'
      preLoaderRoute: typeof AppWsSlugProjectsArchivadosRouteImport
      parentRoute: typeof AppWsSlugProjectsRoute
    }
    '/_app/$wsSlug/settings/areas': {
      id: '/_app/$wsSlug/settings/areas'
      path: '/areas'
      fullPath: '/$wsSlug/settings/areas'
      preLoaderRoute: typeof AppWsSlugSettingsAreasRouteImport
      parentRoute: typeof AppWsSlugSettingsRoute
    }
    '/_app/$wsSlug/settings/general': {
      id: '/_app/$wsSlug/settings/general'
      path: '/general'
      fullPath: '/$wsSlug/settings/general'
      preLoaderRoute: typeof AppWsSlugSettingsGeneralRouteImport
      parentRoute: typeof AppWsSlugSettingsRoute
    }
    '/_app/$wsSlug/settings/integrations': {
      id: '/_app/$wsSlug/settings/integrations'
      path: '/integrations'
      fullPath: '/$wsSlug/settings/integrations'
      preLoaderRoute: typeof AppWsSlugSettingsIntegrationsRouteImport
      parentRoute: typeof AppWsSlugSettingsRoute
    }
    '/_app/$wsSlug/settings/members': {
      id: '/_app/$wsSlug/settings/members'
      path: '/members'
      fullPath: '/$wsSlug/settings/members'
      preLoaderRoute: typeof AppWsSlugSettingsMembersRouteImport
      parentRoute: typeof AppWsSlugSettingsRoute
    }
    '/_app/$wsSlug/settings/telegram': {
      id: '/_app/$wsSlug/settings/telegram'
      path: '/telegram'
      fullPath: '/$wsSlug/settings/telegram'
      preLoaderRoute: typeof AppWsSlugSettingsTelegramRouteImport
      parentRoute: typeof AppWsSlugSettingsRoute
    }
    '/_app/$wsSlug/settings/whatsapp': {
      id: '/_app/$wsSlug/settings/whatsapp'
      path: '/whatsapp'
      fullPath: '/$wsSlug/settings/whatsapp'
      preLoaderRoute: typeof AppWsSlugSettingsWhatsappRouteImport
      parentRoute: typeof AppWsSlugSettingsRoute
    }
    '/_app/$wsSlug/users/$userId': {
      id: '/_app/$wsSlug/users/$userId'
      path: '/$userId'
      fullPath: '/$wsSlug/users/$userId'
      preLoaderRoute: typeof AppWsSlugUsersUserIdRouteImport
      parentRoute: typeof AppWsSlugUsersRoute
    }
    '/_app/$wsSlug/projects/$projectSlug/$itemId': {
      id: '/_app/$wsSlug/projects/$projectSlug/$itemId'
      path: '/$itemId'
      fullPath: '/$wsSlug/projects/$projectSlug/$itemId'
      preLoaderRoute: typeof AppWsSlugProjectsProjectSlugItemIdRouteImport
      parentRoute: typeof AppWsSlugProjectsProjectSlugRoute
    }
    '/_app/$wsSlug/projects/$projectSlug/archivadas': {
      id: '/_app/$wsSlug/projects/$projectSlug/archivadas'
      path: '/archivadas'
      fullPath: '/$wsSlug/projects/$projectSlug/archivadas'
      preLoaderRoute: typeof AppWsSlugProjectsProjectSlugArchivadasRouteImport
      parentRoute: typeof AppWsSlugProjectsProjectSlugRoute
    }
    '/_app/$wsSlug/projects/$projectSlug/board': {
      id: '/_app/$wsSlug/projects/$projectSlug/board'
      path: '/board'
      fullPath: '/$wsSlug/projects/$projectSlug/board'
      preLoaderRoute: typeof AppWsSlugProjectsProjectSlugBoardRouteImport
      parentRoute: typeof AppWsSlugProjectsProjectSlugRoute
    }
    '/_app/$wsSlug/projects/$projectSlug/cycles': {
      id: '/_app/$wsSlug/projects/$projectSlug/cycles'
      path: '/cycles'
      fullPath: '/$wsSlug/projects/$projectSlug/cycles'
      preLoaderRoute: typeof AppWsSlugProjectsProjectSlugCyclesRouteImport
      parentRoute: typeof AppWsSlugProjectsProjectSlugRoute
    }
    '/_app/$wsSlug/projects/$projectSlug/dashboard': {
      id: '/_app/$wsSlug/projects/$projectSlug/dashboard'
      path: '/dashboard'
      fullPath: '/$wsSlug/projects/$projectSlug/dashboard'
      preLoaderRoute: typeof AppWsSlugProjectsProjectSlugDashboardRouteImport
      parentRoute: typeof AppWsSlugProjectsProjectSlugRoute
    }
    '/_app/$wsSlug/projects/$projectSlug/gantt': {
      id: '/_app/$wsSlug/projects/$projectSlug/gantt'
      path: '/gantt'
      fullPath: '/$wsSlug/projects/$projectSlug/gantt'
      preLoaderRoute: typeof AppWsSlugProjectsProjectSlugGanttRouteImport
      parentRoute: typeof AppWsSlugProjectsProjectSlugRoute
    }
    '/_app/$wsSlug/projects/$projectSlug/kpis': {
      id: '/_app/$wsSlug/projects/$projectSlug/kpis'
      path: '/kpis'
      fullPath: '/$wsSlug/projects/$projectSlug/kpis'
      preLoaderRoute: typeof AppWsSlugProjectsProjectSlugKpisRouteImport
      parentRoute: typeof AppWsSlugProjectsProjectSlugRoute
    }
    '/_app/$wsSlug/projects/$projectSlug/list': {
      id: '/_app/$wsSlug/projects/$projectSlug/list'
      path: '/list'
      fullPath: '/$wsSlug/projects/$projectSlug/list'
      preLoaderRoute: typeof AppWsSlugProjectsProjectSlugListRouteImport
      parentRoute: typeof AppWsSlugProjectsProjectSlugRoute
    }
    '/_app/$wsSlug/projects/$projectSlug/minuta': {
      id: '/_app/$wsSlug/projects/$projectSlug/minuta'
      path: '/minuta'
      fullPath: '/$wsSlug/projects/$projectSlug/minuta'
      preLoaderRoute: typeof AppWsSlugProjectsProjectSlugMinutaRouteImport
      parentRoute: typeof AppWsSlugProjectsProjectSlugRoute
    }
    '/_app/$wsSlug/projects/$projectSlug/modules': {
      id: '/_app/$wsSlug/projects/$projectSlug/modules'
      path: '/modules'
      fullPath: '/$wsSlug/projects/$projectSlug/modules'
      preLoaderRoute: typeof AppWsSlugProjectsProjectSlugModulesRouteImport
      parentRoute: typeof AppWsSlugProjectsProjectSlugRoute
    }
    '/_app/$wsSlug/projects/$projectSlug/recurrentes': {
      id: '/_app/$wsSlug/projects/$projectSlug/recurrentes'
      path: '/recurrentes'
      fullPath: '/$wsSlug/projects/$projectSlug/recurrentes'
      preLoaderRoute: typeof AppWsSlugProjectsProjectSlugRecurrentesRouteImport
      parentRoute: typeof AppWsSlugProjectsProjectSlugRoute
    }
    '/_app/$wsSlug/projects/$projectSlug/settings': {
      id: '/_app/$wsSlug/projects/$projectSlug/settings'
      path: '/settings'
      fullPath: '/$wsSlug/projects/$projectSlug/settings'
      preLoaderRoute: typeof AppWsSlugProjectsProjectSlugSettingsRouteImport
      parentRoute: typeof AppWsSlugProjectsProjectSlugRoute
    }
    '/_app/$wsSlug/projects/$projectSlug/cycles/$cycleId': {
      id: '/_app/$wsSlug/projects/$projectSlug/cycles/$cycleId'
      path: '/$cycleId'
      fullPath: '/$wsSlug/projects/$projectSlug/cycles/$cycleId'
      preLoaderRoute: typeof AppWsSlugProjectsProjectSlugCyclesCycleIdRouteImport
      parentRoute: typeof AppWsSlugProjectsProjectSlugCyclesRoute
    }
    '/_app/$wsSlug/projects/$projectSlug/modules/$moduleId': {
      id: '/_app/$wsSlug/projects/$projectSlug/modules/$moduleId'
      path: '/$moduleId'
      fullPath: '/$wsSlug/projects/$projectSlug/modules/$moduleId'
      preLoaderRoute: typeof AppWsSlugProjectsProjectSlugModulesModuleIdRouteImport
      parentRoute: typeof AppWsSlugProjectsProjectSlugModulesRoute
    }
  }
}

interface AppWsSlugProjectsProjectSlugCyclesRouteChildren {
  AppWsSlugProjectsProjectSlugCyclesCycleIdRoute: typeof AppWsSlugProjectsProjectSlugCyclesCycleIdRoute
}

const AppWsSlugProjectsProjectSlugCyclesRouteChildren: AppWsSlugProjectsProjectSlugCyclesRouteChildren =
  {
    AppWsSlugProjectsProjectSlugCyclesCycleIdRoute:
      AppWsSlugProjectsProjectSlugCyclesCycleIdRoute,
  }

const AppWsSlugProjectsProjectSlugCyclesRouteWithChildren =
  AppWsSlugProjectsProjectSlugCyclesRoute._addFileChildren(
    AppWsSlugProjectsProjectSlugCyclesRouteChildren,
  )

interface AppWsSlugProjectsProjectSlugModulesRouteChildren {
  AppWsSlugProjectsProjectSlugModulesModuleIdRoute: typeof AppWsSlugProjectsProjectSlugModulesModuleIdRoute
}

const AppWsSlugProjectsProjectSlugModulesRouteChildren: AppWsSlugProjectsProjectSlugModulesRouteChildren =
  {
    AppWsSlugProjectsProjectSlugModulesModuleIdRoute:
      AppWsSlugProjectsProjectSlugModulesModuleIdRoute,
  }

const AppWsSlugProjectsProjectSlugModulesRouteWithChildren =
  AppWsSlugProjectsProjectSlugModulesRoute._addFileChildren(
    AppWsSlugProjectsProjectSlugModulesRouteChildren,
  )

interface AppWsSlugProjectsProjectSlugRouteChildren {
  AppWsSlugProjectsProjectSlugItemIdRoute: typeof AppWsSlugProjectsProjectSlugItemIdRoute
  AppWsSlugProjectsProjectSlugArchivadasRoute: typeof AppWsSlugProjectsProjectSlugArchivadasRoute
  AppWsSlugProjectsProjectSlugBoardRoute: typeof AppWsSlugProjectsProjectSlugBoardRoute
  AppWsSlugProjectsProjectSlugCyclesRoute: typeof AppWsSlugProjectsProjectSlugCyclesRouteWithChildren
  AppWsSlugProjectsProjectSlugDashboardRoute: typeof AppWsSlugProjectsProjectSlugDashboardRoute
  AppWsSlugProjectsProjectSlugGanttRoute: typeof AppWsSlugProjectsProjectSlugGanttRoute
  AppWsSlugProjectsProjectSlugKpisRoute: typeof AppWsSlugProjectsProjectSlugKpisRoute
  AppWsSlugProjectsProjectSlugListRoute: typeof AppWsSlugProjectsProjectSlugListRoute
  AppWsSlugProjectsProjectSlugMinutaRoute: typeof AppWsSlugProjectsProjectSlugMinutaRoute
  AppWsSlugProjectsProjectSlugModulesRoute: typeof AppWsSlugProjectsProjectSlugModulesRouteWithChildren
  AppWsSlugProjectsProjectSlugRecurrentesRoute: typeof AppWsSlugProjectsProjectSlugRecurrentesRoute
  AppWsSlugProjectsProjectSlugSettingsRoute: typeof AppWsSlugProjectsProjectSlugSettingsRoute
}

const AppWsSlugProjectsProjectSlugRouteChildren: AppWsSlugProjectsProjectSlugRouteChildren =
  {
    AppWsSlugProjectsProjectSlugItemIdRoute:
      AppWsSlugProjectsProjectSlugItemIdRoute,
    AppWsSlugProjectsProjectSlugArchivadasRoute:
      AppWsSlugProjectsProjectSlugArchivadasRoute,
    AppWsSlugProjectsProjectSlugBoardRoute:
      AppWsSlugProjectsProjectSlugBoardRoute,
    AppWsSlugProjectsProjectSlugCyclesRoute:
      AppWsSlugProjectsProjectSlugCyclesRouteWithChildren,
    AppWsSlugProjectsProjectSlugDashboardRoute:
      AppWsSlugProjectsProjectSlugDashboardRoute,
    AppWsSlugProjectsProjectSlugGanttRoute:
      AppWsSlugProjectsProjectSlugGanttRoute,
    AppWsSlugProjectsProjectSlugKpisRoute:
      AppWsSlugProjectsProjectSlugKpisRoute,
    AppWsSlugProjectsProjectSlugListRoute:
      AppWsSlugProjectsProjectSlugListRoute,
    AppWsSlugProjectsProjectSlugMinutaRoute:
      AppWsSlugProjectsProjectSlugMinutaRoute,
    AppWsSlugProjectsProjectSlugModulesRoute:
      AppWsSlugProjectsProjectSlugModulesRouteWithChildren,
    AppWsSlugProjectsProjectSlugRecurrentesRoute:
      AppWsSlugProjectsProjectSlugRecurrentesRoute,
    AppWsSlugProjectsProjectSlugSettingsRoute:
      AppWsSlugProjectsProjectSlugSettingsRoute,
  }

const AppWsSlugProjectsProjectSlugRouteWithChildren =
  AppWsSlugProjectsProjectSlugRoute._addFileChildren(
    AppWsSlugProjectsProjectSlugRouteChildren,
  )

interface AppWsSlugProjectsRouteChildren {
  AppWsSlugProjectsProjectSlugRoute: typeof AppWsSlugProjectsProjectSlugRouteWithChildren
  AppWsSlugProjectsArchivadosRoute: typeof AppWsSlugProjectsArchivadosRoute
  AppWsSlugProjectsIndexRoute: typeof AppWsSlugProjectsIndexRoute
}

const AppWsSlugProjectsRouteChildren: AppWsSlugProjectsRouteChildren = {
  AppWsSlugProjectsProjectSlugRoute:
    AppWsSlugProjectsProjectSlugRouteWithChildren,
  AppWsSlugProjectsArchivadosRoute: AppWsSlugProjectsArchivadosRoute,
  AppWsSlugProjectsIndexRoute: AppWsSlugProjectsIndexRoute,
}

const AppWsSlugProjectsRouteWithChildren =
  AppWsSlugProjectsRoute._addFileChildren(AppWsSlugProjectsRouteChildren)

interface AppWsSlugSettingsRouteChildren {
  AppWsSlugSettingsAreasRoute: typeof AppWsSlugSettingsAreasRoute
  AppWsSlugSettingsGeneralRoute: typeof AppWsSlugSettingsGeneralRoute
  AppWsSlugSettingsIntegrationsRoute: typeof AppWsSlugSettingsIntegrationsRoute
  AppWsSlugSettingsMembersRoute: typeof AppWsSlugSettingsMembersRoute
  AppWsSlugSettingsTelegramRoute: typeof AppWsSlugSettingsTelegramRoute
  AppWsSlugSettingsWhatsappRoute: typeof AppWsSlugSettingsWhatsappRoute
}

const AppWsSlugSettingsRouteChildren: AppWsSlugSettingsRouteChildren = {
  AppWsSlugSettingsAreasRoute: AppWsSlugSettingsAreasRoute,
  AppWsSlugSettingsGeneralRoute: AppWsSlugSettingsGeneralRoute,
  AppWsSlugSettingsIntegrationsRoute: AppWsSlugSettingsIntegrationsRoute,
  AppWsSlugSettingsMembersRoute: AppWsSlugSettingsMembersRoute,
  AppWsSlugSettingsTelegramRoute: AppWsSlugSettingsTelegramRoute,
  AppWsSlugSettingsWhatsappRoute: AppWsSlugSettingsWhatsappRoute,
}

const AppWsSlugSettingsRouteWithChildren =
  AppWsSlugSettingsRoute._addFileChildren(AppWsSlugSettingsRouteChildren)

interface AppWsSlugUsersRouteChildren {
  AppWsSlugUsersUserIdRoute: typeof AppWsSlugUsersUserIdRoute
}

const AppWsSlugUsersRouteChildren: AppWsSlugUsersRouteChildren = {
  AppWsSlugUsersUserIdRoute: AppWsSlugUsersUserIdRoute,
}

const AppWsSlugUsersRouteWithChildren = AppWsSlugUsersRoute._addFileChildren(
  AppWsSlugUsersRouteChildren,
)

interface AppWsSlugRouteChildren {
  AppWsSlugCalendarRoute: typeof AppWsSlugCalendarRoute
  AppWsSlugInboxRoute: typeof AppWsSlugInboxRoute
  AppWsSlugMyWorkRoute: typeof AppWsSlugMyWorkRoute
  AppWsSlugProfileRoute: typeof AppWsSlugProfileRoute
  AppWsSlugProjectsRoute: typeof AppWsSlugProjectsRouteWithChildren
  AppWsSlugSettingsRoute: typeof AppWsSlugSettingsRouteWithChildren
  AppWsSlugTimeRoute: typeof AppWsSlugTimeRoute
  AppWsSlugUsersRoute: typeof AppWsSlugUsersRouteWithChildren
  AppWsSlugIndexRoute: typeof AppWsSlugIndexRoute
}

const AppWsSlugRouteChildren: AppWsSlugRouteChildren = {
  AppWsSlugCalendarRoute: AppWsSlugCalendarRoute,
  AppWsSlugInboxRoute: AppWsSlugInboxRoute,
  AppWsSlugMyWorkRoute: AppWsSlugMyWorkRoute,
  AppWsSlugProfileRoute: AppWsSlugProfileRoute,
  AppWsSlugProjectsRoute: AppWsSlugProjectsRouteWithChildren,
  AppWsSlugSettingsRoute: AppWsSlugSettingsRouteWithChildren,
  AppWsSlugTimeRoute: AppWsSlugTimeRoute,
  AppWsSlugUsersRoute: AppWsSlugUsersRouteWithChildren,
  AppWsSlugIndexRoute: AppWsSlugIndexRoute,
}

const AppWsSlugRouteWithChildren = AppWsSlugRoute._addFileChildren(
  AppWsSlugRouteChildren,
)

interface AppRouteChildren {
  AppWsSlugRoute: typeof AppWsSlugRouteWithChildren
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppAdminFeedbackRoute: typeof AppAdminFeedbackRoute
  AppAdminRolesRoute: typeof AppAdminRolesRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppAdminWhatsappRoute: typeof AppAdminWhatsappRoute
  AppAdminWorkspacesRoute: typeof AppAdminWorkspacesRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppWsSlugRoute: AppWsSlugRouteWithChildren,
  AppOnboardingRoute: AppOnboardingRoute,
  AppAdminFeedbackRoute: AppAdminFeedbackRoute,
  AppAdminRolesRoute: AppAdminRolesRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppAdminWhatsappRoute: AppAdminWhatsappRoute,
  AppAdminWorkspacesRoute: AppAdminWorkspacesRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthResetPasswordRouteChildren {
  AuthResetPasswordConfirmRoute: typeof AuthResetPasswordConfirmRoute
}

const AuthResetPasswordRouteChildren: AuthResetPasswordRouteChildren = {
  AuthResetPasswordConfirmRoute: AuthResetPasswordConfirmRoute,
}

const AuthResetPasswordRouteWithChildren =
  AuthResetPasswordRoute._addFileChildren(AuthResetPasswordRouteChildren)

interface AuthRouteChildren {
  AuthAcceptInviteRoute: typeof AuthAcceptInviteRoute
  AuthChangePasswordRoute: typeof AuthChangePasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAcceptInviteRoute: AuthAcceptInviteRoute,
  AuthChangePasswordRoute: AuthChangePasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicIndexRoute: typeof PublicIndexRoute
  PublicLegalPrivacyRoute: typeof PublicLegalPrivacyRoute
  PublicLegalTermsRoute: typeof PublicLegalTermsRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicIndexRoute: PublicIndexRoute,
  PublicLegalPrivacyRoute: PublicLegalPrivacyRoute,
  PublicLegalTermsRoute: PublicLegalTermsRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
